export const genericErrors = {
    vBirthday: 'This field is not valid',
    vDate: 'This field is not valid',
    vMinLength: 'This field is too short',
    vMaxLength: 'This field is too long',
    vRequired: 'This field is required',
    vPattern: 'This field is not valid',
};
//# sourceMappingURL=content.js.map